import { ISubjectPerformance } from './containers/PerformanceContainer.types';

export enum MarkType {
  AVERAGE = 1,
  FINAL = 2,
}

export enum VisibilityType {
  DIAGRAM = 1,
  TILES = 2,
  CHART = 3,
}

export interface IMappedFinalGrades {
  year: string;
  averageGrade: number;
  educationLevel: string;
  subjects: ISubjectPerformance[];
}

export interface IMappedAverageGrade {
  averageMarkFive: number;
  subjectsPerformance: ISubjectPerformance[];
}

export interface ISubjectTheme {
  name: string;
  passedLessons: number;
  totalLessons: number;
  averageGrade?: number;
}
